import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  withStyles,
  Theme,
  createStyles,
  makeStyles,
} from "@material-ui/core/styles";
import { Grid, TextField } from "@material-ui/core";
import {
  DataGrid,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
} from "@material-ui/data-grid";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import {
  exportCCLedger,
  createInvoice,
  getCenterInfo,
} from "../../actions/GenomicsAdminAction";
import moment from "moment";
import { Button } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
      padding: "5px",
      textTransform: "capitalize",
    },
  })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      width: "90%",
      flexGrow: 21,
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    contentFilter: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    contentTable: {
      width: "100%",
      padding: "0px 0px 10px 0px",
      borderLeft: "solid 1px #0e416b",
      borderRight: "solid 1px #0e416b",
      borderBottom: "solid 1px #0e416b",
      marginTop: "20px",
      minHeight: "300px",
    },
    table: {
      minWidth: 700,
    },
    tableRow: {
      padding: "5px 0 5px 5px !important",
    },
    root: {
      flexGrow: 0,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
  })
);
function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}
interface Props {
  exportCCLedger: any;
  exportCCLedgerData: any;

  getCenterInfo: any;
  centerInfo: any;
  loading: any;
}
const LedgerExport: React.FC<Props> = ({
  exportCCLedger,
  exportCCLedgerData,

  getCenterInfo,
  centerInfo,
  loading,
}) => {
  const timer = useRef<any>(0);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const [startDate, setStartDate] = useState<any>("");

  const [endDate, setEndDate] = useState<any>("");
  const [status, setStatus] = useState<any>("none");
  const [ladgerType, setLedgerType] = useState<any>("none");
  const [centre, setCentre] = useState<any>("");
  const [open, setOpen] = useState<boolean>(false);
  const [invoiceNo, setInvoiceNo] = React.useState<any>("");

  const history = useHistory();

  const dispatch = useDispatch();

  useEffect(() => {
    getCenterInfo();
  }, []);
  const searchHandler = (e: any) => {
    e.preventDefault();
    exportCCLedger(
      `?center__id=${centre}&start_date=${startDate}&end_date=${endDate}`
    );
  };
  const columns: GridColDef[] = [
    { field: "sno", headerName: "Sr. No.", width: 150 },
    { field: "billno", headerName: "Bill No.", width: 150 },
    { field: "paymentdate", headerName: "Payment date", width: 150 },
    { field: "pname", headerName: "Patient Name", width: 250 },
    { field: "age", headerName: "Age", width: 150 },
    { field: "gender", headerName: "Gender", width: 150 },
    { field: "tcode", headerName: "Test Code", width: 150 },
    { field: "tname", headerName: "Test name", width: 150 },
    { field: "iscoupon", headerName: "Is Coupon", width: 150 },
    { field: "gross", headerName: "Gross", width: 150 },
    { field: "clientshareperc", headerName: "Client Share(%)", width: 250 },
    { field: "clientshare", headerName: "Client Share", width: 200 },
    { field: "creditdebit", headerName: "Credit/Debit", width: 200 },
    { field: "rclshare", headerName: "Rcl share", width: 150 },
    { field: "balance", headerName: "Balance", width: 150 },
  ];

  let rows = [];

  if (exportCCLedgerData && exportCCLedgerData.length > 0) {
    rows =
      exportCCLedgerData &&
      exportCCLedgerData.length > 0 &&
      exportCCLedgerData.map((qual: any, index: any) => {
        return {
          id: qual.id,
          sno: index + 1,
          billno: qual.booking,
          pname: qual.customer_name,
          age: qual.customer_age,
          gender: qual.customer_gender,
          tcode: qual.package_code,
          tname: qual.package_name,
          iscoupon: qual.camp_coupon,
          gross: qual.amount,
          clientshareperc: qual.client_discount_percentage,
          clientshare: Number(qual.client_share).toFixed(2),
          creditdebit: qual.ledger_type,
          rclshare: Number(qual.rcl_share).toFixed(2),
          balance: Number(qual.center_rem_balance).toFixed(2),
          paymentdate: moment(qual.created_at).format("DD-MM-YYYY"),
        };
      });
  }
  return (
    <>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <div className={classes.contentHeader}>
          <h4>Export Genomics Ledger</h4>
        </div>

        <div className={classes.root}>
          <Grid container spacing={2}>
            <form onSubmit={searchHandler} style={{ width: "100%" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} md={3} lg>
                  <Autocomplete
                    id="center"
                    onChange={(event, newValue) => {
                      if (newValue) {
                        let obj = JSON.parse(
                          JSON.stringify(newValue, null, " ")
                        );
                        setCentre(obj.id);
                      }
                    }}
                    freeSolo
                    blurOnSelect
                    options={centerInfo?.results || []}
                    disabled={centerInfo?.results === undefined}
                    disableCloseOnSelect
                    getOptionLabel={(option: any) =>
                      (option?.display_name === null
                        ? option?.name
                        : option?.display_name) +
                      "(" +
                      option?.center_code +
                      ")"
                    }
                    onInputChange={(event, newInputValue) => {
                      getCenterInfo(`&name_or_code=${newInputValue}`);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Hospital/Doctor"
                        variant="outlined"
                        fullWidth
                        required
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg>
                  <TextField
                    label="From Date"
                    id="contract-date"
                    type="date"
                    value={startDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => setStartDate(e.target.value)}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} sm={4} md={3} lg>
                  <TextField
                    label="To Date"
                    id="contract-date"
                    type="date"
                    value={endDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => setEndDate(e.target.value)}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    style={{ height: "100%" }}
                    type="submit"
                    // onClick={searchHandler}
                  >
                    Filter
                  </Button>
                </Grid>
                <Grid item xs={12} sm={4} md={3} lg>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    style={{ height: "100%" }}
                    onClick={() =>
                      history.push("/dashboard/gnadmin/cc_Ledger_export")
                    }
                  >
                    Clear
                  </Button>
                </Grid>
              </Grid>
            </form>

            <Grid container item xs={12}>
              <div style={{ height: 550, width: "100%" }}>
                <DataGrid
                  rowsPerPageOptions={[]}
                  rows={rows}
                  columns={columns}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
                  pageSize={50}
                  loading={loading}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </main>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  exportCCLedgerData: state.GenomicsAdminReducer.exportCCLedgerData,
  centerInfo: state.GenomicsAdminReducer.centerInfo,
  loading: state.GenomicsAdminReducer.loading,
});

export default connect(mapStateToProps, {
  exportCCLedger,
  createInvoice,
  getCenterInfo,
})(LedgerExport);
